"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberDirectoryFilterTypes = exports.AccountIndustries = exports.AccountTypes = exports.AccountSizes = void 0;
exports.AccountSizes = {
    FROM_1_TO_10: 1,
    FROM_11_TO_25: 2,
    FROM_26_TO_100: 3,
    FROM_101_TO_250: 4,
    FROM_251_TO_500: 5,
    FROM_501_TO_1000: 6,
    FROM_1001_TO_5000: 7,
    OVER_5000: 8,
};
exports.AccountTypes = {
    BUSINESS: 1,
    NON_PROFIT: 2,
    GOVERNMENT: 3,
    INDIVIDUAL_OR_GROUP: 4,
    SCHOOL: 5,
};
exports.AccountIndustries = {
    ACCOUNTING: 28,
    ADVERTISING_OR_MARKETING_AGENCY: 24,
    AGRICULTURE: 36,
    ART_CULTURE_AND_HUMANITIES: 14,
    AUTOMOTIVE: 37,
    CLUB_OTHER: 26,
    CLUB_SPORTS: 27,
    CONSTRUCTION: 29,
    CONSUMER: 1,
    EDUCATION: 2,
    ENERGY_AND_UTILITIES: 3,
    ENVIRONMENT_AND_ANIMALS: 15,
    FEDERAL_GOVERNMENT: 21,
    FINANCE: 4,
    FRANCHISE: 31,
    GOVERNMENT: 5,
    HEALTH_AND_HUMAN_SERVICES: 16,
    HEALTH_CARE: 6,
    INTERNATIONAL_OR_FOREIGN_AFFAIRS: 17,
    LOCAL_GOVERNMENT: 22,
    LAW: 30,
    MANUFACTURING: 7,
    MARKETING_AGENCY: 35,
    MATERIALS: 8,
    MEMBERSHIP: 18,
    NON_PROFIT: 9,
    NUTRITION: 38,
    PROFESSIONAL_SERVICES: 12,
    REAL_ESTATE: 32,
    RELIGIOUS: 19,
    RESTAURANT: 39,
    RETAIL: 33,
    SOCIAL_BENEFIT: 20,
    SPORTS: 25,
    STATE_GOVERNMENT: 23,
    TECHNOLOGY: 10,
    TELECOMMUNICATIONS: 34,
    TRANSPORTATION: 11,
    OTHER: 13,
};
exports.MemberDirectoryFilterTypes = {
    ALL: 1,
    TEAM: 2,
    EMAIL_DOMAIN: 3,
    NOBODY: 4,
};
